import { Box } from "@mui/material";
import React from "react";
import "./animate.css";

const LoadingApp: React.FC = () => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      height={"100vh"}
    >
      <div className={"pulse"}>
        <img src="/images/atem-logotipo.png" width={70} height={48} alt="logo atem" />
      </div>
    </Box>
  );
};

export default LoadingApp;
